import { Position, Toaster } from "@blueprintjs/core";

export const toaster = Toaster.create({
  position: Position.BOTTOM
});

export default toaster;
